import CMSPageCollection from '@netx/core-cms/collections/CMSPages';

export const currentPortalPages = new CMSPageCollection([], {parse: false});
